const AppConfig = {
  appName: "Maintain CMMS"
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/Config/AppConfig.ts